<template>
  <div
    class="sb-block-ui"
    v-bind="rootProps"
    :class="computedClass"
    @mousedown="$emit('mousedown', $event)"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { reactiveOmit } from '@vueuse/core'
import { computed, type HTMLAttributes } from 'vue'

export type SbBlockUiProps = {
  inElement?: boolean
  fullWidth?: boolean
} & /* @vue-ignore */ HTMLAttributes

const props = defineProps<SbBlockUiProps>()

const rootProps = reactiveOmit(props, ['inElement', 'fullWidth'])

defineEmits<{
  (e: 'mousedown', event: MouseEvent): void
}>()

const computedClass = computed(() => ({
  'sb-block-ui--in-element': props.inElement,
  'sb-block-ui--full-width': props.fullWidth,
}))
</script>
